module.exports = __webpack_public_path__ + "img/scuola1_white.a3f84910.svg";